import React from 'react';

import './css/ServerDiagram.css'

import frameSources from './callToActionFrames'
import { useCursorRimLight } from './rimLight'


// The "your storage -> your server -> fan" diagram, drawn in the page rather
// than shipped as a flat image, so it sits on the dark ground. Still: the
// only thing that moves is the rim light on its border, which every frame of
// the home page shares.

// The wordmark, as drawn at the end of the logo reveal.
const LOGO: string = frameSources[ frameSources.length - 1 ]


function StorageGlyph(): React.JSX.Element {
	// Three stacked discs: a full top ellipse, the side walls closed by the
	// bottom curve, and the two status dots of the original drawing.
	const discs: number[] = [ 18, 58, 98 ]

	return (
		<svg className="ServerDiagram-Glyph" viewBox="0 0 104 146" fill="none" aria-hidden="true" >
			{ discs.map( ( y: number ): React.JSX.Element => (
				<g key={ y } >
					<path className="ServerDiagram-Stroke" d={ `M8 ${ y } a44 13 0 1 0 88 0 a44 13 0 1 0 -88 0` } />
					<path className="ServerDiagram-Stroke" d={ `M8 ${ y } v26 a44 13 0 0 0 88 0 v-26` } />
					<circle className="ServerDiagram-Fill" cx="74" cy={ y + 19 } r="2.4" />
					<circle className="ServerDiagram-Fill" cx="84" cy={ y + 19 } r="2.4" />
				</g>
			) ) }
		</svg>
	)
}


function InfraGlyph(): React.JSX.Element {
	return (
		<svg className="ServerDiagram-Glyph" viewBox="0 0 64 132" fill="none" aria-hidden="true" >
			<path className="ServerDiagram-Stroke" d="M16 3 H48 A13 13 0 0 1 61 16 V116 A13 13 0 0 1 48 129 H16 A13 13 0 0 1 3 116 V16 A13 13 0 0 1 16 3 Z" />
			<rect className="ServerDiagram-Fill" x="23" y="8" width="18" height="5" rx="2.5" />
			<rect className="ServerDiagram-Fill" x="22" y="118" width="20" height="3" rx="1.5" />
		</svg>
	)
}


function Arrow(): React.JSX.Element {
	return (
		<div className="ServerDiagram-Arrow" aria-hidden="true" >
			<svg className="ServerDiagram-Arrow-Glyph" viewBox="0 0 48 16" fill="none" >
				<path d="M1 8 H40" />
				<path d="M33.5 2.5 L40.5 8 L33.5 13.5" />
			</svg>
		</div>
	)
}


export function ServerDiagram(): React.JSX.Element {

	const rootRef = React.useRef<HTMLDivElement>( null )
	useCursorRimLight( rootRef )

	return (
		<div
			className="ServerDiagram"
			ref={ rootRef }
			role="img"
			aria-label="Your storage and Underlayer sit inside your own environment and serve the fan directly; no third party SaaS cloud is in the path."
		>
			<div className="ServerDiagram-Row" >

				<div className="ServerDiagram-Node" >
					<div className="ServerDiagram-Figure ServerDiagram-Figure-Storage" >
						<StorageGlyph />
					</div>
					<div className="ServerDiagram-Label" >Your storage</div>
				</div>

				<Arrow />

				<div className="ServerDiagram-Node ServerDiagram-Node-Server" >
					<div className="ServerDiagram-Figure ServerDiagram-Figure-Server" >
						<div className="ServerDiagram-Card" >
							<img className="ServerDiagram-Card-Logo" src={ LOGO } alt="" />
						</div>
					</div>
					<div className="ServerDiagram-Label" >Your server</div>
				</div>

				<Arrow />

				<div className="ServerDiagram-Node" >
					<div className="ServerDiagram-Figure ServerDiagram-Figure-Infra" >
						<InfraGlyph />
					</div>
					<div className="ServerDiagram-Label" >Fan</div>
				</div>

			</div>

			<div className="ServerDiagram-Excluded" >
				<svg className="ServerDiagram-Excluded-Glyph" viewBox="0 0 24 24" fill="none" aria-hidden="true" >
					<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
					<path d="M21 3 L3 21" />
				</svg>
				<span className="ServerDiagram-Excluded-Label" >third party saas cloud</span>
			</div>
		</div>
	)

}
